module.exports = __webpack_public_path__ + "img/ancient_wendigo_small.aa0039a2.png";